import { CookiesConsentType } from 'types/CookiesConsentType';

declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

export type ConsentModeValue = 'granted' | 'denied';

export type ConsentModeObject = {
  analytics_storage: ConsentModeValue;
  ad_storage: ConsentModeValue;
  ad_user_data: ConsentModeValue;
  ad_personalization: ConsentModeValue;
  functionality_storage: ConsentModeValue;
  personalization_storage: ConsentModeValue;
  security_storage: ConsentModeValue;
};

// Single source of truth for the Brij-banner -> Google Consent Mode mapping.
// Used by BOTH the gtag consent update below and the event-level snapshot
// (utils/getCookieConsent.ts) so what Google is told and what events carry
// can never drift apart.
export const mapCookiesConsentToConsentMode = (
  consent: CookiesConsentType
): ConsentModeObject => ({
  analytics_storage: consent.analytics ? 'granted' : 'denied',
  ad_storage: consent.marketing ? 'granted' : 'denied',
  ad_user_data: consent.marketing && consent.analytics ? 'granted' : 'denied',
  ad_personalization: consent.marketing ? 'granted' : 'denied',
  functionality_storage: consent.functional ? 'granted' : 'denied',
  personalization_storage: consent.social ? 'granted' : 'denied',
  security_storage: 'granted',
});

export const updateConsentMode = (consent: CookiesConsentType) => {
  if (typeof window.gtag === 'function') {
    window.gtag('consent', 'update', mapCookiesConsentToConsentMode(consent));
  }
};

export const triggerConsentEvent = () => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'brij-cookies-initiation',
  });
};
